<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';
// import { isExternal } from '@/utils/validate'
import Item from './Item';
import AppLink from './Link';
import FixiOSBug from './FixiOSBug';

export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    mixins: [FixiOSBug],
    props: {
    // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    data() {
        this.onlyOneChild = null;
        return {};
    },
    methods: {
        hasOneShowingChild(children = [], parent) {
            const showingChildren = children.filter(item => {
                if (item.hidden) {
                    return false;
                }
                // Temp set(will be used if only has one showing child)
                this.onlyOneChild = item;
                return true;

            });

            // When there is only one child router, the child router is displayed by default
            if (showingChildren.length === 1) {
                return true;
            }

            // Show parent if there are no child router to display
            if (showingChildren.length === 0) {
                this.onlyOneChild = { ... parent, path: '', noShowingChildren: true };
                return true;
            }

            return false;
        },
        resolvePath(routePath) {
            /* if (isExternal(routePath)) {
                return routePath;
            }
            if (isExternal(this.basePath)) {
                return this.basePath;
            }*/
            return path.resolve(this.basePath, routePath);
        }
    }
};
</script>
<style lang="scss">
@import "../../../styles/theme.scss";

.el-menu {
    border: none;
}

// Scoped to the sidebar itself: a flyout submenu (collapsed sidebar,
// popper-append-to-body) is also an .el-menu but lives outside
// .sidebar-container, so it keeps its own solid background.
.sidebar-container .el-menu {
    background-color: transparent;
}

li.el-menu-item,
.el-submenu__title {
    display: flex;
    align-items: center;
    color: $issue-text-muted;
    transition: background-color .12s ease, color .12s ease;

    .svg-icon {
        flex-shrink: 0;
    }

    &:hover {
        background-color: $issue-bg-subtle !important;
        color: $issue-text;
    }
}

li.el-menu-item.is-active {
    position: relative;
    background-color: $issue-primary-soft;
    color: $issue-primary;
    font-weight: 600;

    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background-color: $issue-primary;
    }

    &:hover {
        background-color: $issue-primary-soft !important;
        color: $issue-primary;
    }
}

// Nested submenu items read as a secondary level: a touch smaller,
// with the arrow and title picking up the accent color while open.
.el-submenu .el-menu-item {
    font-size: 13px;
}

.el-submenu__icon-arrow {
    color: $issue-text-muted;
}

.el-submenu.is-opened > .el-submenu__title {
    color: $issue-text;
    font-weight: 600;

    .el-submenu__icon-arrow {
        color: $issue-primary;
    }
}

// Each item is wrapped in a router-link <a>; without this, Bootstrap's
// global a:hover{text-decoration:underline} draws a line through the item.
.el-menu a,
.el-menu a:hover,
.el-menu a:focus {
    text-decoration: none;
}

// Element's own collapse rule only hides the label span when .el-submenu
// is a *direct* child of .el-menu--collapse. SidebarItem.vue wraps every
// item in its own <div>, breaking that chain, so the label (and the
// arrow) would otherwise stay visible in the icon-only collapsed sidebar.
.el-menu--collapse .el-submenu__title span,
.el-menu--collapse li.el-menu-item span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
}

.el-menu--collapse .el-submenu__icon-arrow {
    display: none;
}
</style>
